module.exports = __webpack_public_path__ + "img/errorpage.320a7bb6.svg";